import styled from "styled-components";

import { ShoppingCartTicketStyledProps as Props } from "./ShoppingCartTicket.types";
import CONSTANTS from "config/constants";

const { mobile, tablet } = CONSTANTS.BREAKPOINTS;

const ShoppingCartTicketStyled = styled.div<Props>`
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3.2rem;
  border-radius: 1rem;
  background-color: var(--palette-mid-blue-s15-l20);
  overflow: hidden;
  margin-bottom: 1.6rem;

  @media (max-width: ${tablet}px) {
    padding: 2.4rem;

    &:last-child {
      margin-bottom: 14rem;
    }
  }

  .ShoppingCartTicket {
    &__content {
      font-size: 1.6rem;
      font-weight: 700;
      display: flex;
      justify-content: space-between;

      &__right {
        float: right;
        align-self: center;
        padding: 0 2.4rem;

        @media (max-width: ${tablet}px) {
          padding: 0 0.8rem;
        }
      }

      &__left {
        float: left;
        padding: 0 2rem;

        @media (max-width: ${tablet}px) {
          padding: 0 0.8rem;
        }

        @media (max-width: ${tablet - 1}px) {
          padding: 0 0.8rem;
          width: 50%;
        }
      }
    }

    &__title {
      margin-bottom: 0.4rem;
      font-weight: 600;
      font-size: 1.8rem;
      color: var(--palette-white);

      @media (max-width: ${tablet}px) {
        font-size: 1.6rem;
      }
    }

    &__price {
      font-size: 1.6rem;
      font-weight: 700;
      color: var(--palette-gray-s0-l80);
    }

    &__warning {
      color: var(--palette-red-s95-l65);
      font-size: 1rem;
      padding-bottom: 0.8rem;
    }

    &__dot-container {
      position: absolute;
      justify-content: center;
      top: 50%;
      transform: translateY(-50%);

      @media (max-width: ${tablet}px) {
        top: 3.2rem;
      }

      @media (max-width: ${mobile}px) {
        top: 4rem;
      }
    }

    &__dot {
      width: 3.2rem;
      height: 3.2rem;
      background-color: var(--palette-dark-blue-s13-l11);
      border-radius: 12rem;
    }

    &__left-dot-container {
      left: -1.6rem;
    }

    &__right-dot-container {
      right: -1.6rem;
    }
  }
`;

export default ShoppingCartTicketStyled;
